import { Locale, LocaleType } from "./Locale";

export default class UserAccount {
    constructor(
        public firstName="",
        public lastName="",
        public email = "",
        public password = "",
        public country = "-",
        public fittingLocation = "",
        public shipToNumber = "",
        public locale: LocaleType = Locale.english
    ) {}
}
